import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGameStore } from "@/stores/gameStore";
import { useUserInfoStore } from "@/stores/userInfoStore";
import GameOverDialogView from "@/views/game/GameOverDialogView.vue";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'GameOverDialogPresenter',
  setup(__props) {

const gameStore = useGameStore();
const { gameMode, gameState, isAttacker } = storeToRefs(gameStore);

const subject = gameMode.value === "local" ? "The Attacker" : "You";
const didWin =
  subject == "You"
    ? isAttacker.value == gameState.value.isAttackerWinner
    : gameState.value.isAttackerWinner;

const message = `${subject} ${didWin ? "won" : "lost"}!`;

const userInfoStore = useUserInfoStore();
const { rating } = storeToRefs(userInfoStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameOverDialogView, {
    message: message,
    "new-rating": _unref(rating)
  }, null, 8, ["new-rating"]))
}
}

})